import React from 'react';

import { customTheme } from 'theme';

export const yAxisTickWithPercent = props => {
  const { x, y, payload } = props;
  return (
    <g transform={`translate(${x - 8},${y})`}>
      <text
        fill="#666"
        fontSize={14}
        alignmentBaseline="middle"
        textAnchor="end"
      >
        {payload.value}%
      </text>
    </g>
  );
};

export const CustomTooltip = props => {
  const { active, payload, label } = props;
  if (active && payload && payload.length) {
    return (
      <div>
        <p className="label">{`${label} : ${payload[0].value * 1000}`}</p>
      </div>
    );
  }

  return null;
};

export const historyChartStyles = () => ({
  bar: {
    fill: customTheme.colors.primary,
  },
  line: {
    stroke: customTheme.colors.green['300'],
    dot: false,
  },
  areaChart: {
    margin: {
      top: 0,
    },
  },
  legend: {
    wrapperStyle: {
      top: -5,
      right: -5,
    },
  },
  yAxis: {
    domain: [0, 100],
    tickLine: false,
    axisLine: false,
    style: {
      textAlign: 'right',
    },
    tick: props => yAxisTickWithPercent(props),
  },
  firstYAxis: {
    tickLine: false,
    axisLine: false,
  },
  xAxis: {
    tickLine: false,
    interval: 10,
    padding: { right: -10, left: -10 },
  },
});
